import {
  normalizeSignupAttribution,
  type SignupAttribution,
} from "../../shared/signupAttribution";

const SIGNUP_ATTRIBUTION_STORAGE_KEY = "darsi_signup_attribution_v1";

export function captureFirstTouchSignupAttribution(): SignupAttribution {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const stored = window.localStorage.getItem(SIGNUP_ATTRIBUTION_STORAGE_KEY);
    if (stored !== null) {
      return normalizeSignupAttribution(JSON.parse(stored));
    }

    const params = new URLSearchParams(window.location.search);
    const attribution = normalizeSignupAttribution({
      signupUtmSource: params.get("utm_source"),
      signupUtmMedium: params.get("utm_medium"),
      signupUtmCampaign: params.get("utm_campaign"),
      signupUtmContent: params.get("utm_content"),
      signupReferrer: document.referrer,
    });
    window.localStorage.setItem(
      SIGNUP_ATTRIBUTION_STORAGE_KEY,
      JSON.stringify(attribution),
    );
    return attribution;
  } catch {
    return {};
  }
}

export function readSignupAttribution(): SignupAttribution {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const stored = window.localStorage.getItem(SIGNUP_ATTRIBUTION_STORAGE_KEY);
    return stored === null
      ? captureFirstTouchSignupAttribution()
      : normalizeSignupAttribution(JSON.parse(stored));
  } catch {
    return {};
  }
}

export function clearSignupAttribution(): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.removeItem(SIGNUP_ATTRIBUTION_STORAGE_KEY);
  } catch {
    // Attribution must never affect authentication or product behavior.
  }
}
